<template>
  <div
    id="conteudo-modal-processo-detalhes"
    class="modal-list-content"
    style="overflow: auto; padding: 8px 28px"
  >
    <div class="columns container-historico-timeline-detalhes is-flex-direction-row-reverse">
      <div class="column is-6 is-flex is-flex-direction-column container-detalhes-form">
        <div id="secao-detalhes">
          <h3 class="is-size-5 pl-2">Detalhes</h3>
          <p class="pl-5 mt-3">
            <strong>Empresa:</strong> {{ detalhesProcesso.empresa }}
          </p>
          <p class="pl-5 mt-1">
            <strong>Responsável:</strong>
            {{ detalhesProcesso.responsavel }}
          </p>
          <p class="pl-5 mt-1">
            <strong>Departamento:</strong>
            {{ detalhesProcesso.departamento }}
          </p>
          <p class="pl-5 mt-1 prazo-entrega">
            <strong>Prazo de entrega:</strong>
            {{ detalhesProcesso.prazoDeEntrega }}
          </p>
        </div>

        <hr />

        <div id="secao-descricao" v-if="!isDescricaoVazia()">
          <h3 class="is-size-5 pl-2">{{ isFase ? 'Descrição da fase' : 'Descrição do processo' }}</h3>
          <div id="trf-detalhes-processo-descricao" class="pl-5 pr-5 mt-3 content" v-html="detalhesProcesso.descricao">
          </div>
        </div>
        <div id="secao-descricao" v-else>
          <h3 class="is-size-6 pl-2 has-text-grey">{{ isFase ? 'Não há descrição para esta fase.' : 'Não há descrição para este processo.' }}</h3>
        </div>

        <hr/>
        
        <TrfGestorAnexos
          :historico-id="historicoId"
          :fase-id="isFase ? faseId : null"
          :is-tarefa-concluida="isFaseConcluida"
          :is-tarefa-do-legalize="true"
          :show-upload-button="isFase"
          :show-delete-button="true"
          :status-id="statusId"
          @anexos-alterados="handleAnexosAlterados"
        />

        <hr />

        <div id="secao-comentario" data-cy="secao-comentario">
          <h3 v-if="!this.comentario.isEdicao" class="is-size-5 pl-2">Comentário:<span class="button is-loading is-white pl-2 pr-2 is-inline-block" style="height: 1.25em" v-if="isToolbarTextEditorLoading"></span></h3>
          <h3 v-else class="is-size-5 pl-2"> Edição de Comentário:<span class="button is-loading is-white pl-2 pr-2 is-inline-block" style="height: 1.25em" v-if="isToolbarTextEditorLoading"></span></h3>
          <div class="is-flex is-flex-direction-column is-align-items-flex-end">
            <TrfToolbarTextEditor
              :tipLabel="tipLabelComentario"
              :maxlength="comentario.maxLength"
              @changeText="doChangeComentario"
              @ready="($event) => ( isToolbarTextEditorLoading = $event)"
              ref="textEditor"
              data-cy="campo-comentario"
            />
            <div v-if="!this.comentario.isEdicao" class="is-flex is-flex-direction-row is-align-content-space-around is-align-items-center">
            <TrfButton
              :disabled="isCampoComentarioVazio()"
              @click="adicionarComentario()"
              nome="Adicionar"
              :class="{'mt-3': true, 'is-loading': comentario.isSalvando}"
              classCor="is-primary"
              id="btn-adicionar-comentario"
              data-cy="btn-adicionar-comentario"
              :title="isCampoComentarioVazio()? `Preencha um comentário para habilitar a ação.` : ``"
            />
            </div>
            <div v-else class="is-flex is-flex-direction-row is-align-content-space-between is-align-items-center">
              <TrfButton
              :disabled="isCampoComentarioVazio()"
              @click="montarObjetoEdicaoComentario()"
              nome="Alterar"
              :class="{'mt-3': true, 'is-loading': comentario.isEditando}"
              classCor="is-primary"
              id="btn-adicionar-comentario"
              data-cy="btn-alterar-comentario"
              :title="isCampoComentarioVazio()? `Preencha um comentário para habilitar a ação.` : ``"
            />
            <TrfButton
              @click="editarTituloToolBoxEBotoes(),this.limparComentario()"
              nome="Cancelar"
              :class="{'mt-3 ml-3': true}"
              classCor="is-light"
              id="btn-cancelar-comentario"
              data-cy="btn-cancelar-edicao-comentario"
              :title="isCampoComentarioVazio()? `Preencha um comentário para habilitar a ação.` : ``"
            />
            </div>
          </div>
        </div>
      </div>

      <div
        class="
          is-flex is-justify-content-center is-align-items-center
          separador-colunas
        "
      >
        <span></span>
      </div>

      <div
        id="trf-historico-processo"
        class="column is-6 secao-historico-timeline"
        @scroll="TrfMixAderirAoInfiniteScroll"
        data-cy="secao-historico"
      >
        <h3 class="is-size-5 pl-2">Histórico</h3>
        <div
          class="is-relative"
          :class="{ 'is-flex': !showTimeline }"
        >
          <TrfGlobalLoader
            type="overlay"
            v-if="showTimelineLoader"
            overlayColor="#FFF"
          />

          <div v-if="showTimeline">
            <TrfTimeline :historicos-tarefa="historicosProcesso" :tarefa="detalhesProcesso" :objetoEdicaoTarefa="this.gerarObjetoParaArvore()" ref="timelineComponent" @carrega-historico="_carregarHistoricoTimeline(true)" @edicao-comentario="edicaoComentario" @limpa-campos="this.limparComentario(),this.editarTituloToolBoxEBotoes()"/>
            <div
              v-if="
                TrfMixInfiniteScroll.listagemCarregando &&
                !TrfMixInfiniteScroll.paginacaoFinalizada
              "
            >
              <span
                class="
                  button
                  is-large is-fullwidth is-loading
                  trf-is-borderless
                  mt-3
                "
              ></span>
            </div>
          </div>

          <div v-else id="msg-processo-sem-timeline" class="m-auto">
            <p class="is-size-5 pl-2">{{ isFase ? 'Não há históricos para essa fase.' : 'Não há históricos para esse processo.' }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import { TrfMixinInfiniteScroll } from "../../mixins/infinitescroll";
import { utils } from "../../util/utils";
import { defineAsyncComponent } from 'vue';
import { statusEnum } from '../../enums/statusEnum';

export default {
  name: "TrfDetalhesProcesso",
  components: {
    TrfTimeline: defineAsyncComponent(() => import('../Timeline/index.vue')),
    TrfGlobalLoader: defineAsyncComponent(() => import('../GlobalLoader/index.vue')),
    TrfToolbarTextEditor: defineAsyncComponent(() => import("../ToolbarTextEditor/index.vue")),
    TrfButton: defineAsyncComponent(() => import('../Button/index.vue')),
    TrfGestorAnexos: defineAsyncComponent(() => import('../GestorAnexos/index.vue')),
  },
  mixins: [TrfMixinInfiniteScroll],
  props: {
    processo: {
      type: Object,
      default: () => {},
    },
    listaResponsaveis: {
        type: Array,
        required: true,
        default: () => []
    },
    isFase: {
      type: Boolean,
      default: false
    },
    faseId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      showTimeline: true,
      showTimelineLoader: false,
      historicosProcesso: [],
      isToolbarTextEditorLoading: true,
      comentario: {
        html: "",
        plainText: "",
        maxLength: 5000,
        isSalvando: false,
        isEditando: false,
        isEdicao: false
      },
      objetoEdicaoProcesso: [],
      showGlobalLoader: false,
      hasAnexosAlterados: false
    };
  },
  computed: {
    tipLabelComentario() {
      let count = this.comentario.maxLength;
      if(this.comentario.plainText) {
        count -= this.comentario.plainText.length;
      }
      const tipo = this.isFase ? 'fase' : 'processo';
      return `Adicione informações complementares ${this.isFase ? 'à' : 'ao'} ${tipo}, caso necessário - ${count} caracteres restantes.`;
    },     
    getId() {
      if (!this.processo) {
        return null
      }
      if (this.isFase && this.faseId) {
        return this.faseId;
      }
      return this.processo.historicoTarefas.faseId ? this.processo.historicoTarefas.faseId : this.processo.historicoTarefas.id;
    },
    detalhesProcesso() {
      if (!!!this.processo || this.processo == {}) {
        return {};
      }

      const dadosFase = this.isFase && this.faseId 
        ? this.processo.historicoTarefas?.fases?.find(f => f.id === this.faseId)
        : null;

      const responsavelId = this.isFase ? dadosFase?.responsavelId : this.processo?.historicoTarefas?.responsavelId;
      const responsavelEncontrado = this.listaResponsaveis.find(r => r.value == responsavelId);

      const detalhesProcesso = {
        tarefaId: this.getId,
        nome: dadosFase?.nome || this.processo.nomeNegocio,
        empresa: `${this.processo.empresa.externoId} - ${this.processo.empresa.nome}`,
        responsavel: responsavelEncontrado?.label || "---",
        departamento: dadosFase?.departamento?.nome || this.processo.departamento.nome,
        prazoDeEntrega: utils.formatarDataParaExibicaoNoDataTable(
          dadosFase?.prazoEntrega || this.processo?.dataPrevisaoConclusao
        ),
        prazoLegal: utils.formatarDataParaExibicaoNoDataTable(this.processo?.dataPrevisaoConclusao),
        descricao: this.isFase ? dadosFase?.descricao : this.processo.detalheNegocio,
        fases: this.isFase ? null : this.processo.historicoTarefas.fases,
        isFase: this.isFase
      };
      return detalhesProcesso;
    },

    filtrosRequisicaoCardHistoricoTimeline() {
      const historicoId = this.isFase 
        ? this.processo.historicoTarefas.id 
        : (this.processo.historicoTarefas.faseId || this.processo.historicoTarefas.id);
      
      const objetoDeFiltro = {
        "historicoTarefa": historicoId,
        "fase": this.isFase ? this.faseId : (this.processo.faseId || ""),
        "sort[DESC]": "id",
        pagina: this.TrfMixInfiniteScroll.page || 1,
        limit: this.TrfMixInfiniteScroll.limit || 100
      };
      return objetoDeFiltro;
    },

    historicoId() {
      return this.isFase ? this.processo.historicoTarefas.id : (this.processo.historicoTarefas.faseId || this.processo.historicoTarefas.id);
    },
    statusId() {
      if (this.isFase && this.faseId) {
        const fase = this.processo.historicoTarefas?.fases?.find(f => f.id === this.faseId) || 
                     this.processo.tarefa?.fases?.find(f => f.id === this.faseId);
        return fase?.status?.id?.toString() || null;
      }
      return this.processo?.historicoTarefas?.status?.id?.toString() || null;
    },
    isFaseConcluida() {
      return this.statusId && this.statusId === statusEnum.CONCLUIDO;
    }
  },
  methods: {
    doChangeComentario(value) {
      const plainText = this.$refs.textEditor.getValueAsText();
      if(plainText.length > this.comentario.maxLength) {
        return;
      }

      this.comentario.html = value;
      this.comentario.plainText = plainText;
    },
    limparComentario() {
      this.comentario.html = "";
      this.comentario.plainText = "";      
      if(!this.$refs.textEditor) return;
      this.$refs.textEditor.limparCampo()
    },
    async importTimelineTarefasService() {
      const { timelineTarefasService } = await import('../../service/timeline-tarefas-service.js');
      return timelineTarefasService;
    },
    async adicionarComentario() {
      this.comentario.isSalvando = true;
      const registro = this.gerarObjetoParaArvore();
      const timelineTarefasService = await this.importTimelineTarefasService();
      const request = await timelineTarefasService.adicionarRegistro(registro);
      if(request.ok) {
        this._carregarHistoricoTimeline(true);
        this.limparComentario();
      }
      this.comentario.isSalvando = false;
    },
    gerarObjetoParaArvore() {
      const hoje = utils.formatarCampoDataParaEnvioAoBackendSemHora(new Date());
      const registroHistorico = {
        dataDaAcao: hoje,
        acao: "Comentário",
        possuiParecerAtendimento: true,
        descricaoAcao: this.comentario.html,
        historicoTarefaId: this.isFase ? this.processo.historicoTarefas.id : this.getId,
        faseId: this.isFase ? this.faseId : (this.processo.historicoTarefas.faseId || null),
      }

      return registroHistorico;
    },
    isCampoComentarioVazio() {
      const hasNotProcesso = !!!this.processo;
      const hasNotComentarioPreenchido = this.comentario.plainText <= 0;
      return hasNotProcesso || hasNotComentarioPreenchido;
    },
    isDescricaoVazia() {
      const hasNotProcesso = !!!this.processo;

      const plainText = this.HTMLStringToPlainText(this.detalhesProcesso.descricao);
      const hasNotDescricao = !!!this.detalhesProcesso.descricao || this.detalhesProcesso.descricao == "" && plainText.length <= 0;

      return hasNotProcesso || hasNotDescricao;
    },
    async TrfMixIncrementarPagina(page, limit) {
      this.TrfMixInfiniteScroll.page = page + 1;
      this.TrfMixInfiniteScroll.limit = limit;
      const request = await this._carregarHistoricoTimeline(false);
    },
    async _carregarHistoricoTimeline(resetar) {
      try {
        if (!!resetar) {
          this.resetarPaginacao();
        }
        const timelineTarefasService = await this.importTimelineTarefasService();
        const listaDeHistoricosTimeline = await timelineTarefasService.listar(
          this.filtrosRequisicaoCardHistoricoTimeline
        );
        await Promise.all(
          listaDeHistoricosTimeline.data.map(async (historico) => {
            historico.dataDaAcao = utils.formatarDataParaExibicaoNoDataTable(
              historico.dataDaAcao
            );
            historico.cor =
              this.atribuirCorAoCardDeAcordoComAcaoHistoricoTimeline(
                historico.acao
              );
            historico.foto = historico?.responsavel?.fotoId?
              historico?.responsavel?.fotoId :
              null
          })
        );
        this.historicosProcesso = [
          ...this.historicosProcesso,
          ...listaDeHistoricosTimeline.data,
        ];
        const total = parseInt(listaDeHistoricosTimeline.totalDeItens);
        this.TrfMixInfiniteScroll.paginacaoFinalizada =
          total == this.historicosProcesso.length;
        if(total == 0) {
          this.showTimeline = false;
        } else {
          this.showTimeline = true;
        }
      } catch (erro) {
        if (erro.name === "AbortError") {
          console.warn(
            "INFO: Carregamento da timeline cancelado pelo usuário."
          );
        } else {
          console.error(erro);
        }
      } finally {
        this.showTimelineLoader = false;
        const container = document.querySelector('#trf-historico-processo');
        if(!this.isScrollable(container)) {
          this.realizarPaginacao(container);
        }
      }
    },    
    resetarPaginacao() {
      this.showTimelineLoader = true;
      this.TrfMixInfiniteScroll.page = 1;
      this.TrfMixInfiniteScroll.limit = 3;
      this.TrfMixInfiniteScroll.paginacaoFinalizada = false;
      this.historicosProcesso = [];
    },
    atribuirCorAoCardDeAcordoComAcaoHistoricoTimeline(acao) {
      switch (acao) {
        case 'Comentário':
        case 'Comentário interno':
        case 'Anexo':
          return  "#6BC8B3"; 
        case 'Enviado':
          return "#587EAB";
        case 'Reabertura':
          return "#CDAD00"; 
        case 'Concluído':
          return "#66BB06";
        case 'Recorrência':
          return "#bcb7b7";
        case 'Edição': 
          return "#CDAD00";
        case 'Paralisada':
        case 'Paralisado':
          return "#666666";
        case 'Continuação':
          return "#cdad00";
        case 'Aguardando dados':
          return "#547CAC";
        case 'Aguardando conferência':
          return "#c4b43c";
      }
    },
    HTMLStringToPlainText(htmlString, trim = 0) {
      let tempDiv = document.createElement("div");
      tempDiv.innerHTML = htmlString;

      let plainText = tempDiv.textContent || tempDiv.innerText || "";

      if(trim > 0 && !isNaN(trim)) {
        plainText = plainText.substring(0,trim);
        plainText = plainText.trim();
      }

      return plainText;
    },
    async _iniciarProcesso() {
      this.showTimelineLoader = true;
      const carregamentoHistorico = await this._carregarHistoricoTimeline(true);
    },
    async _fecharProcesso() {
      const conteudoComScroll = document.getElementById("conteudo-modal-historico-detalhes");
      const timelineTarefasService = await this.importTimelineTarefasService();
      timelineTarefasService.abortarUltimoRequest('get');
      timelineTarefasService.abortarUltimoRequest('post');
      this.limparComentario();
      if(!!this.$refs.timelineComponent) {
        this.$refs.timelineComponent.closeAllCards();
      }
      if(!!conteudoComScroll) {
        setTimeout(() => {
          conteudoComScroll.scrollTo(0,0)
        }, 500);
      }
    },
    async edicaoComentario(data) {
      this.comentario.isEdicao = true;
      this.comentario.html = this.$refs.textEditor.iniciarTextEditorComValor(data.descricaoAcao);
      await this.$nextTick();
      this.comentario.plainText = this.$refs.textEditor.getValueAsText();
    },
    editarTituloToolBoxEBotoes() {
      this.comentario.isEdicao = false;
      this.comentario.isEditando = false;
    },
    montarObjetoEdicaoComentario() {
      this.comentario.isEditando = true;
      this.$refs.timelineComponent.alterarComentario();
    },
    async handleAnexosAlterados() {
      this.hasAnexosAlterados = true;
      await this._carregarHistoricoTimeline(true);
      this.$emit('anexos-alterados');
    }
  },
  mounted() {
  },
  watch: {
    processo: {
      immediate: true,
      async handler(novoProcesso) {
        if(!!novoProcesso?.faseId || !!novoProcesso?.id) {
          const iniciar = await this._iniciarProcesso();
        } else {
          await this._fecharProcesso();
        }
      }
    },
  }
};
</script>
  
<style lang="scss" scoped>
.modal-list-content {
  max-height: 100%;
  &::-webkit-scrollbar {
    width: 5px;
    height: 0px;
    @media screen and (max-width: 768px) {
      width: 2px;
    }
  }
  &::-webkit-scrollbar-track {
    background: #dbdbdb;
    border-radius: 9px;
    margin: 12px 0;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #969696;
    border-radius: 11px;
    border: 0px none #969696;
  }
  @media screen and (min-width: 1024px) {
    width: 1024px;
  }
  @media only screen and (min-width:100px) and (max-width:999px){
    height: 100%;
  }
}
.container-historico-timeline-detalhes{
  margin-bottom: 0;
  margin-top: 0;
}

.secao-historico-timeline {
  overflow-y: auto;
  padding-right: 0;
  margin-right: 12px;
  scrollbar-width: thin;
  scrollbar-color: #969696 #dbdbdb;
  max-height: 747px;
  @media screen and (max-width: 1023px) {
    max-height: none;
  }
}
 .secao-historico-timeline::-webkit-scrollbar , div#secao-descricao::-webkit-scrollbar {
  width: 5px;
  height: 0px;
  @media screen and (max-width: 768px) {
    width: 2px;
  }
}
 .secao-historico-timeline::-webkit-scrollbar-track , div#secao-descricao::-webkit-scrollbar-track {
  background: #dbdbdb;
  border-radius: 9px;
  margin: 12px 0;
}
 .secao-historico-timeline::-webkit-scrollbar-thumb , div#secao-descricao::-webkit-scrollbar-thumb {
  background-color: #969696;
  border-radius: 11px;
  border: 0px none #969696;
}
.trf-is-borderless {
  border:0 none!important;
  outline: 0 none!important;
}
div#secao-descricao {
  max-height: 200px;
  overflow: auto;
  flex-grow:1;
}
div#msg-processo-sem-timeline p {
  color:#31708f;
  text-align: center;
}
.separador-colunas span {
  border-left: 1px solid hsl(0deg, 0%, 86%);
  height: calc(100% - 30px);
  @media screen and (max-width: 768px) {
    border-bottom: 1px solid hsl(0deg, 0%, 86%);
    width: calc(100% - 10px);
  }
}
hr {
  background: hsl(0deg, 0%, 86%);
  height: 1px;
}
.prazo-entrega {
  display: inline-block;
  @media screen and (max-width: 768px) {
    display: block;
  }
}
.container-detalhes-form {
  max-height: 100%;
  flex-grow: 1;
  @media screen and (max-width: 768px) {
    max-height: none;
  }
}

label,input[type='checkbox'] {
  margin-top: 12px;
  margin-bottom: 0;
  font-weight: 100;
  margin-right: 8px
}

</style>
  